module.exports = __webpack_public_path__ + "static/media/5.3bddb121.jpg";